import React from 'react'
/* --------------------------------------------- */
// import tickImg from '../../../imgs/landing/Vector-78.png'
/* --------------------------------------------- */
import Button from "../../form/Button"
import TickIcon from '../../icons/TickIco';

import { ImgContainer, InfoSubTitle, InfoTitle, InfoDesc, ButtonWrapper, InfoCtaDesc } from './styles'
import "./_landing-page.scss";

/* --------------------------------------------- */

const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

// GenericSection component for showing pageComponent
const GenericSection = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const { sectionData = {}, themeSection:theme = {} } = props
  const {graphics:[imagesData = {}] = [],body = {}} = theme
  const {images:backgroundImages = []} = imagesData
  const {background = {}} = body
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])

  const {subTitle, title, description, ctaData, ctaDescription, listData, graphics} = sectionData

  const genericInfo = (
    <div className="generic-infoContainer">
      {
        subTitle && (
          <InfoSubTitle {...{ theme }} className='infoSection__subtitle'>{title}</InfoSubTitle>
        )
      }
      {
        title && (
          <InfoTitle {...{ theme }} className='infoSection__title'>{subTitle}</InfoTitle>
        )
      }
      {
        description && (
          <InfoDesc {...{ theme }} className='infoSection__desc infoSection__label'>{description}</InfoDesc>
        )
      }
      {
        listData && listData.map((data, idx) => {
          return (
            <div className="list-detail" key={idx}>
              <TickIcon color={theme?.body?.accent?.primary} width={"16px"} height={'11px'} className="list-img" />
              {/* <img src={tickImg} className="list-img" alt="subscription-list"/> */}
              <InfoDesc {...{ theme }} className='infoSection__desc'>{data.label}</InfoDesc>
            </div>
          )
        })
      }
      {
        ctaData && (
          <ButtonWrapper {...{ theme: theme?.compositeTheme }}>
              <Button {...{ title: ctaData }}  onClick={()=>{}} />
          </ButtonWrapper>
        )
      }
      {
        ctaDescription && (
          <InfoCtaDesc {...{ theme }} className='infoSection__ctadesc'>{ctaDescription}</InfoCtaDesc>
        )
      }
    </div>
  )

  const genericAsset = (
    <div className="generic-assetContainer">
      <img src={graphics?.img} className="generic-asset" alt="asset"/>
    </div>
  )

  if (parseInt(vw) <= 650) {
    return (
      <ImgContainer {...{ images: backgroundImages[0]?.url || background?.primary  }}>
        <div className='generic-detail'>
          {genericAsset}
          {genericInfo}
        </div>
      </ImgContainer>
    )
  }

  return (
    <ImgContainer style={{backgroundColor:background?.primary}} {...{ images: backgroundImages[0]?.url }}>
      <div className='generic-detail'>
        {
          graphics?.anchor === 'center-right' ? (
            <>
              {genericInfo}
              {genericAsset}
            </>
          ) : (
            <>
              {genericAsset}
              {genericInfo}
            </>
          )
        }
      </div>
    </ImgContainer>
  )
}


/* --------------------------------------------- */
GenericSection.propTypes = {

}
/* --------------------------------------------- */
GenericSection.defaultProps = {

}
/* --------------------------------------------- */
export default GenericSection
